// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__31RIT","spinner":"styles_spinner__2C7_t"};